var LOCALE = window.LOCALE || {};
LOCALE.de = {
    ERROR: 'Ups!',
    ERROR_UNDEFINED: 'Undefinierter Fehler',
    ERROR_APP: 'Etwas lief schief. Bitte lade die Seite neu, um fortzufahren. Wir entschuldigen uns für die Unannehmlichkeiten. Bitte kontaktiere den Support, falls der Fehler besteht.',
    ERROR_REQUIRED_FP_VER: 'Um fortzufahren musst du Adobe Flash Player auf dieser Seite aktivieren.\nDas Spiel unterstützt keine Versionen ohne Flash Player.',
    ACTION_UPDATE_FP: 'Erlauben',
    PLEASE_RELOAD: 'Bitte lade die Seite neu',
    ACTION_RELOAD: 'Aktualisieren',
    GAME: 'Spielen',
    SUPPORT: 'Support',
    COMMUNITY: 'Community',
    YOUR_ID: 'Deine ID',
    LOADING: 'Laden…',
    GAME_NAME: 'Lords of the Arena',
    ERROR_SOCIAL: 'Social Network Fehler',
    LIKE_BUTTON_TITLE: 'Lords of the Arena',
    LIKE_BUTTON_DESCRIPTION: 'Lords of the Arena Spiel',
    FAQ: 'FAQ',
    ACTION_INVITE: 'Einladen',
    SIG_SERVER_22: 'Das Spiel ist vorübergehend nicht erreichbar aufgrund einer Serverwartung. Bitte versuche es später noch einmal.',
    INVITE_MESSAGE: 'Kämpfe mit mir in dem neuen Strategiespiel. Große Kämpfe erwarten uns!',
    INVITE_TITLE: 'Lords of the Arena!',
    FP_DIALOG_MESSAGE1: 'To start the game you need to launch Flash player',
    FP_DIALOG_ENABLE1: 'If the window does not appear, open that link in a new tab:',
    FP_DIALOG_ENABLE2: 'chrome://settings/content/flash',
    FP_DIALOG_ENABLE3: 'Disable "Prevent sites from running Flash" setting, then return to game and click "Launch!" button once again.',
    FP_DIALOG_RUN: 'Launch!',
    FP_DIALOG_ALLOW: 'A new dialog window should appear. Click "Allow".',
    SWF_PLAYER_FALLBACK_NOTICE: 'Wenn Sie Probleme beim Laden des Spiels haben, können Sie die Option "Wechseln zu Flash" im oberen Menü verwenden.',
    SWITCH_TO_SWF_PLAYER: 'Wechseln zu Flash',
    SWITCH_TO_HTML_PLAYER: 'Wechseln zu HTML'
};
